import axios from 'axios'
import decryptData from '@/store/auth/decryptData'

export default {
  namespaced: true,
  state: () => ({
    mainCertificate: [],
    mainCertificateLoaded: false,
  }),
  mutations: {
    SET_MAIN_CERTIFICATE(state, mainCertificate) {
      state.mainCertificate = mainCertificate
      state.mainCertificateLoaded = true
    },
  },
  actions: {
    async fetchMainCertificate({ commit, state }) {
      if (!state.mainCertificateLoaded) {
        const response = await axios.get('certificate_group')
        const data = decryptData(response.data.payload)?.data?.certificates
        const formatted = data.map(item => ({
          value: item.id,
          text: `${item.name?.ar} - ${item.name?.en}`,
        }))

        commit('SET_MAIN_CERTIFICATE', [...formatted])
      }
    },
  },
  getters: {
    mainCertificate: state => state.mainCertificate,
    mainCertificateLoaded: state => state.mainCertificateLoaded,
  },
}
